import React from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Link } from 'react-router-dom';
import style from './profilebar.module.scss';

export function ProfileBar() {
  // unused relese 1 start -
  // const firstName = localStorage.getItem('AirswiftFirstName');
  // - end
  return (
    <Link to="/my-profile" className={style.profile_bar}>
      <span className={style.halo_1}>
        {' '}
        {/* toggle class names halo_1 - halo_4 for significant role */}
        <span className={style.inner_halo}>
          {/* conditional rendering of avatar <img> or placeholder <AccountCircleIcon> with azure b2c auth */}
          {/* user avatar rendred here in <img> tag, changes in profile pic should be shown here */}
          <img src="" alt="" />
          <AccountCircleIcon sx={{ fontSize: 36 }} />
        </span>
      </span>
      {/* <strong>{firstName}</strong>
      <div className={style.icon}>
        <ArrowDropDownIcon />
      </div> */}
    </Link>
  );
}
